import { render, staticRenderFns } from "./SubGlobalNavigationBar.vue?vue&type=template&id=189e282c"
import script from "./SubGlobalNavigationBar.ts?vue&type=script&lang=ts&external"
export * from "./SubGlobalNavigationBar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports